import ucp from '../api/ucp';

import { setUserInfo } from './ProfileActions';
import { LOGIN_RESULT, SET_INITIAL_STATE } from '../utils/actionType';
import { BaseURL } from '../utils/baseURL';

export const setUsuarioAction = user => ({
  type: LOGIN_RESULT,
  payload: user,
});

export const LoginAction = (values, callback) => async dispatch => {
  const user = { ...values };

  try {
    const { data } = await ucp.post(`${BaseURL}/auth/login`, user);
    if (data.token) {
      sessionStorage.setItem('Authorization', data.token);
      if (data.user && callback && typeof callback === 'function') {
        await dispatch(setUserInfo(data.user));
        callback({ sucesso: true, message: 'Logado com sucesso!' });
      } else if (callback && typeof callback === 'function') {
        sessionStorage.removeItem('Authorization');
        callback({ sucesso: false, message: 'Erro ao acessar o servidor.' });
      }
    } else if (callback && typeof callback === 'function')
      callback({ sucesso: false, message: 'Usuário ou Senha Incorretos!' });
  } catch (error) {
    if (callback && typeof callback === 'function')
      callback({ sucesso: false, message: 'Erro ao acessar o servidor.' });
  }
};

export const LogoutAction = () => dispatch => {
  sessionStorage.removeItem('Authorization');
  dispatch({ type: SET_INITIAL_STATE });
};
